<div class="loading" *ngIf="loading">
  <mat-spinner diameter="40"></mat-spinner>
</div>

<div class="concurso-detalhe" *ngIf="concurso">
  <mat-form-field appearance="outline" class="concurso-selector">
    <mat-label>Concurso</mat-label>
    <input matInput
           #selectorInput
           type="text"
           aria-label="Selecionar concurso (Ctrl+K)"
           [formControl]="searchControl"
           [matAutocomplete]="auto"
           (focus)="onSelectorFocus()"
           (blur)="onSelectorBlur()"
           (click)="$any($event.target).select()">
    <mat-icon matSuffix matTooltip="Ctrl+K para buscar">unfold_more</mat-icon>
    <mat-autocomplete #auto="matAutocomplete"
                      (optionSelected)="selecionarConcurso($event.option.value)"
                      [displayWith]="displayFn">
      <mat-option *ngFor="let c of concursosFiltrados$ | async" [value]="c">
        {{ c.titulo }}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>

  <nav mat-tab-nav-bar [tabPanel]="tabPanel" color="primary" aria-label="Abas do concurso">
    <ng-container *ngFor="let tab of tabs; let i = index">
      <a mat-tab-link
         *ngIf="tab.visible"
         [routerLink]="tab.route"
         routerLinkActive
         #rla="routerLinkActive"
         [active]="rla.isActive"
         [matTooltip]="tab.tooltip"
         (keydown)="onTabKeydown($event, i)">
        <mat-icon class="tab-icon">{{ tab.icon }}</mat-icon>
        {{ tab.label }}
      </a>
    </ng-container>
  </nav>

  <mat-tab-nav-panel #tabPanel class="tab-content">
    <router-outlet></router-outlet>
  </mat-tab-nav-panel>
</div>
